import { OnlineFulfillmentFormController } from "./OnlineFulfillmentFormController";
import { QrWaiterFulfillmentFormController } from "./QrWaiterFulfillmentFormController";
export const FulfillmentFormController = {
    create(params) {
        switch (params.fulfillmentInstructions.type) {
            case "Online": {
                if (params.fulfillmentTime.type !== "Online") {
                    throw new Error("FulfillmentInstructions and PFulfillmentTime type mismatch");
                }
                return new OnlineFulfillmentFormController({
                    purchaseOrderFulfillmentTime: params.purchaseOrderFulfillmentTime,
                    fulfillmentInstructions: params.fulfillmentInstructions,
                    fulfillmentTime: params.fulfillmentTime,
                    geocodingService: params.geocodingService,
                    geolocationService: params.geolocationService,
                    viewType: params.viewType,
                });
            }
            case "QrWaiter":
                return new QrWaiterFulfillmentFormController({
                    fulfillmentInstructions: params.fulfillmentInstructions,
                });
        }
    },
};
